import { createContext, useContext } from "react";
import type { DatabaseAdapter } from "./DatabaseAdapter";

const DatabaseContext = createContext<DatabaseAdapter | null>(null);

export function DatabaseProvider({
    adapter,
    children
}: {
    adapter: DatabaseAdapter;
    children: React.ReactNode;
}) {
    return <DatabaseContext.Provider value={adapter}>{children}</DatabaseContext.Provider>;
}

export function useDatabase(): DatabaseAdapter {
    const db = useContext(DatabaseContext);
    if (!db) throw new Error("useDatabase must be used within a DatabaseProvider");
    return db;
}
